import React, { useState } from "react";
import { FC } from "react";
import CompareAnuallyPlans from "./CompareAnnualPlan";
import AnnualPricingPlans from "./AnnualPlan";

export const fftt = [false, false, true, true];
export const allt = [true, true, true, true];
export const ftft = [false, true, false, true];
export const fttt = [false, true, true, true];
export const ffft = [false, false, false, true];

const Anually: FC = () => {
  const [selectedPlan, setSelectedPlan] = useState<string | null>(null); // Track the selected plan

  // Example data for the pricing cards and comparison table
  const plans = [
    {
      title: "Free",
      amount: "NGN 0",
      user: "Per 1 user",
      type: "",
      benefits: ["1 Project", "Storage 500MB"],
      buttonTitle: "Contact Us",
      free: "",
      hasDropdown: false,
      baseAmount: 0,
    },
    {
      title: "Basic",
      amount: "NGN 20,000",
      user: "Per user/ project",
      type: "",
      benefits: ["10 projects", "Storage 5GB"],
      free: "All in Free +",
      buttonTitle: "Contact Us",
      hasDropdown: true,
      baseAmount: 20000,
    },
    {
      title: "Pro",
      type: "",
      amount: "NGN 45,000",
      user: "Per project",
      benefits: ["Unlimited projects", "Storage 50GB"],
      free: "All in Basic +",
      buttonTitle: "Contact Us",
      hasDropdown: true,
      baseAmount: 45000,
    },
    {
      title: "Enterprise",
      type: "Contact Us",
      amount: "",
      user: "",
      free: "All in Pro +",
      buttonTitle: "Contact Us",
      benefits: [
        "Unlimited members",
        "Unlimited projects",
        "Storage 100GB or more",
      ],
      hasDropdown: false,
      baseAmount: 0,
    },
  ];

  return (
    <div className="container mx-auto p-6">
      <AnnualPricingPlans
        plans={plans}
        selectedPlan={selectedPlan}
        setSelectedPlan={setSelectedPlan}
      />

      <CompareAnuallyPlans
        plans={plans}
        compareItems={compareItems}
        selectedPlan={selectedPlan}
        setSelectedPlan={setSelectedPlan}
      />
    </div>
  );
};

export const compareItems = [
  {
    feature: "Plan limits",
    subFeatures: [
      {
        name: "Users included",
        availability: ["1", "10", "50", "Custom"],
      },
      {
        name: "Active projects",
        availability: ["1", "10", "Unlimited", "Unlimited"],
      },
      {
        name: "Shared storage",
        availability: ["500 MB", "5 GB", "50 GB", "100 GB or more"],
      },
    ],
  },
  {
    feature: "Overview",
    subFeatures: [
      {
        name: "Dashboard",
        availability: allt,
      },
      {
        name: "Project clusters",
        availability: fttt,
      },
    ],
  },
  {
    feature: "Communication",
    subFeatures: [
      {
        name: "Team member messaging",
        availability: fttt,
      },
      {
        name: "Task-based messaging",
        availability: fftt,
      },
      {
        name: "Group messaging",
        availability: fftt,
      },
      {
        name: "Scheduled meetings",
        availability: fttt,
      },
      {
        name: "Site instructions",
        availability: fttt,
      },
    ],
  },
  {
    feature: "Scheduling",
    subFeatures: [
      {
        name: "Create work programmes",
        availability: allt,
      },
      {
        name: "Work programme templates",
        availability: fttt,
      },
      {
        name: "Gantt Chart",
        availability: allt,
      },
      {
        name: "Table View",
        availability: allt,
      },
      {
        name: "Kanban View",
        availability: allt,
      },
      {
        name: "Resource management",
        availability: [false, "Limited", "Full", "Full"],
      },
      {
        name: "Task tracking",
        availability: allt,
      },
    ],
  },
  {
    feature: "Team",
    subFeatures: [
      {
        name: "Team management",
        availability: fttt,
      },
      {
        name: "Task assignments",
        availability: fttt,
      },
      {
        name: "Roles and access control",
        availability: ["Personal", "Standard", "Advanced", "Custom"],
      },
    ],
  },
  {
    feature: "Procurement",
    subFeatures: [
      {
        name: "Bids and procurement",
        availability: fftt,
      },
      {
        name: "Inventory management",
        availability: [false, "Limited", "Full", "Full"],
      },
    ],
  },
  {
    feature: "Finance",
    subFeatures: [
      {
        name: "Disbursement planning and tracking",
        availability: fftt,
      },
      {
        name: "Payment tracking",
        availability: fftt,
      },
      {
        name: "Invoicing",
        availability: fftt,
      },
      {
        name: "Expense tracking",
        availability: fttt,
      },
    ],
  },
  {
    feature: "Documents",
    subFeatures: [
      {
        name: "File and folder management",
        availability: allt,
      },
    ],
  },
  {
    feature: "Photos and Videos",
    subFeatures: [
      {
        name: "Photos and Videos",
        availability: allt,
      },
    ],
  },
  {
    feature: "Reporting and Analytics",
    subFeatures: [
      {
        name: "Reports and analytics",
        availability: ["Basic", "Basic", "Advanced", "Custom"],
      },
      {
        name: "CSV and PDF export",
        availability: [false, true, true, true],
      },
    ],
  },
  {
    feature: "Automations and Approvals",
    subFeatures: [
      {
        name: "Automations",
        availability: [false, "Limited", true, true],
      },
      {
        name: "Approval workflows",
        availability: [false, false, true, true],
      },
    ],
  },
  {
    feature: "Integrations",
    subFeatures: [
      {
        name: "Integrations and API",
        availability: [false, false, "Limited", "Full"],
      },
      {
        name: "Custom integrations",
        availability: [false, false, false, "By agreement"],
      },
    ],
  },
  {
    feature: "Security and Governance",
    subFeatures: [
      {
        name: "Audit logs",
        availability: [false, false, false, true],
      },
      {
        name: "SSO with SAML",
        availability: [false, false, false, true],
      },
      {
        name: "Data retention controls",
        availability: [false, false, false, true],
      },
      {
        name: "Custom branding",
        availability: [false, false, false, true],
      },
    ],
  },
  {
    feature: "Payment",
    subFeatures: [
      {
        name: "Billing frequency",
        availability: [
          "None",
          "Monthly or Annual",
          "Monthly or Annual",
          "Annual or Agreed",
        ],
      },
      {
        name: "Payment methods",
        availability: [
          "None",
          "Card",
          "Card",
          "Card, Invoice, Cheque or Transfer",
        ],
      },
    ],
  },
  {
    feature: "Notification",
    subFeatures: [
      {
        name: "Email notifications",
        availability: fttt,
      },
      {
        name: "In-app notifications",
        availability: allt,
      },
    ],
  },
  {
    feature: "Support",
    subFeatures: [
      {
        name: "Help center",
        availability: allt,
      },
      {
        name: "Feature request priority",
        availability: [false, false, "Priority", "Highest"],
      },
      {
        name: "In-app and email support",
        availability: fttt,
      },
      {
        name: "Priority support",
        availability: fftt,
      },
      {
        name: "Slack support",
        availability: fftt,
      },
      {
        name: "Dedicated Slack channel",
        availability: ffft,
      },
      {
        name: "Dedicated support manager",
        availability: ffft,
      },
      {
        name: "Guided onboarding",
        availability: ffft,
      },
      {
        name: "Contractual SLA",
        availability: ffft,
      },
    ],
  },
  // {
  //   feature: "Security",
  //   subFeatures: [
  //     {
  //       name: "Fine grained permission control",
  //       availability: fttt,
  //     },
  //     {
  //       name: "2FA",
  //       availability: allt,
  //     },
  //     {
  //       name: "On prem hosting",
  //       availability: ["", "", "", "Coming Soon"],
  //     },
  //   ],
  // },
];

export default Anually;
